export const UPLOAD_BRAND_IMAGE_REQUEST = "UPLOAD_BRAND_IMAGE_REQUEST";
export const UPLOAD_BRAND_IMAGE_SUCCESS = "UPLOAD_BRAND_IMAGE_SUCCESS";
export const UPLOAD_BRAND_IMAGE_FAILURE = "UPLOAD_BRAND_IMAGE_FAILURE";
export const UPLOAD_BRAND_IMAGE_RESET = "UPLOAD_BRAND_IMAGE_RESET";
export const uploadBrandImageSuccess = (payload) => ({
    type: UPLOAD_BRAND_IMAGE_SUCCESS,
    payload,
});
export const uploadBrandImageRequest = (payload) => ({
    type: UPLOAD_BRAND_IMAGE_REQUEST,
    payload,
});
export const uploadBrandImageFailure = (payload) => ({
    type: UPLOAD_BRAND_IMAGE_FAILURE,
    payload,
});
export const uploadBrandImageReset = (payload) => ({
    type: UPLOAD_BRAND_IMAGE_FAILURE,
    payload,
});
